import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addLogo: 'Add my logo',
    description:
      'Add **your company logo** to customise your quotes and invoices',
  },
  fr: {
    addLogo: 'Ajouter mon logo',
    description: 'Personnalisez vos devis et factures avec **votre logo**',
  },
} as const);

export default locales;
